import { render, staticRenderFns } from "./LastReleases.vue?vue&type=template&id=46c7eee4&scoped=true&"
import script from "./LastReleases.vue?vue&type=script&lang=js&"
export * from "./LastReleases.vue?vue&type=script&lang=js&"
import style0 from "./LastReleases.vue?vue&type=style&index=0&id=46c7eee4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c7eee4",
  null
  
)

export default component.exports